import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Briefcase, Activity, FileText, Shield, AlertTriangle, Users, Settings, Sun, Moon, LogOut } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const menuItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/audit-jobs', icon: Briefcase, label: 'Audit Jobs' },
  { path: '/active-scans', icon: Activity, label: 'Active Scans' },
  { path: '/reports', icon: FileText, label: 'Reports' },
  { path: '/authorization', icon: Shield, label: 'Authorization Records' },
  { path: '/vulnerabilities', icon: AlertTriangle, label: 'Vulnerabilities' },
  { path: '/users', icon: Users, label: 'Users' },
  { path: '/settings', icon: Settings, label: 'Settings' }
];

export const Sidebar = () => {
  const { theme, toggleTheme } = useTheme();
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Shield className="logo-icon" />
        <h1 className="logo-text">SecureOps</h1>
      </div>
      
      {user && (
        <div className="sidebar-user-info">
          <div className="user-avatar">
            {user.name?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-details">
            <div className="user-name">{user.name || 'User'}</div>
            <div className="user-email">{user.email}</div>
          </div>
        </div>
      )}
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            end={item.path === '/'}
            data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <item.icon className="nav-icon" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="theme-toggle-container">
          <button
            onClick={toggleTheme}
            className="theme-toggle-btn"
            aria-label="Toggle theme"
            data-testid="theme-toggle"
          >
            {theme === 'dark' ? (
              <>
                <Sun className="theme-icon" />
                <span>Light Mode</span>
              </>
            ) : (
              <>
                <Moon className="theme-icon" />
                <span>Dark Mode</span>
              </>
            )}
          </button>
        </div>

        <button
          onClick={handleLogout}
          className="logout-btn"
          aria-label="Logout"
          data-testid="logout-button"
        >
          <LogOut className="logout-icon" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};
